import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import { obj } from '@/util'

export const UserRoutes = {

	ShowUserWithTenants: async () => {
		return await api().get(getRoute('api.user.self'))
	},

	GetUserOnTenant: async (tenant) => {
		return await api().get(getRoute('api.tenant.user', { tenant }))
	}

}

export const LoginRoutes = {

	Login: async (data) => {
		return await api().post(getRoute('login.post'), data)
	},

	Logout: async () => {
		return await api().post(getRoute('logout.post'))
	}

}

export const RegistrationRoutes = {

	NewRegistration: async (params, signature, expires, signedParams) => {
		let sign = getRoute('register.store', Object.assign(signedParams, {
			expires: expires,
			signature: signature,
		}));
		return await api().post(sign, obj.objToFormData(params))
	}
}

export const TenantRegistrationRoutes = {

	Store: async (data) => {
		return await api().post(getRoute('tenant.register.store'), data)
	},
	FreeTrial: async (data) => {
		return await api().post(getRoute('tenant.register.free-trial'), data)
	},
}

export const EmailVerificationRoutes = {

	SendVerificationEmail: async () => {
		return await api().post(getRoute('verification.send'));
	}

}

export const ConfirmPasswordRoutes = {

	CheckPasswordIsCorrect: async (data) => {
		return await api().post(getRoute('password.confirmation.check'), data)
	},

	CheckPasswordIsConfirmed: async () => {
		return await api().get(getRoute('password.confirmation.status'))
	}

}

export const PasswordRoutes = {

	SendResetLink: async (data) => {
		return await api().post(getRoute('password.request'), data)
	},

	SaveNewPassword: async (data) => {
		return await api().post(getRoute('password:update'), data)
	},

	UpdatePassword: async (data) => {
		return await api().put(getRoute('password.change'), data)
	}

}

export const ProfileRoutes = {

	UpdateProfile: async (data) => {
		data._method = 'PUT'

		// TODO: Terrible hack. Change this later
		// Note that profile picture won't save with just "data" and email_subscriptions won't save with "obj.objToFormData(data)"
		let finalData = data.email_subscriptions ? data : obj.objToFormData(data);
		return await api().post(getRoute('profile.update'), finalData)
	}

}

export const TwoFactorRoutes = {

	Enable: async () => {
		return await api().post(getRoute('two-factor.store'))
	},
	Disable: async () => {
		return await api().delete(getRoute('two-factor.destroy'))
	},
	SubmitChallenge: async (data) => {
		return await api().post(getRoute('two-factor.challenge'), data)
	},
	ShowQrCode: async () => {
		return await api().get(getRoute('two-factor.get-qr'))
	},
	GetRecoveryCodes: async () => {
		return await api().get(getRoute('two-factor.get-recovery'))
	},
	UpdateRecoveryCodes: async () => {
		return await api().post(getRoute('two-factor.send-recovery'))
	}


}

export const BrowserSessionsRoutes = {

	GetAllSessions: async () => {
		return await api().get(getRoute('browser-session.index'))
	},

	DestroySessions: async (data) => {
		return await api().delete(getRoute('browser-session.destroy'), { data })
	}

}

export const LoginProviderRoutes = {

	GetAllAvailable: async () => {
		return await api().get(getRoute('api.loginProviders.index'))
	},
	GetAllForUser: async () => {
		return await api().get(getRoute('api.activeLoginProviders.index'))
	},
	RemoveActiveForUser: async (provider) => {
		return await api().delete(getRoute('api.activeLoginProviders.destroy', { provider }))
	}

}
